import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { RadioButton, TextCallout1 } from 'blocket-ui'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

const ItemsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-left: 16px;
`

const ItemWrapper = styled.div`
  padding: 0 5px;
  display: flex;
  align-items: center;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }
`

const createItems = (items, required) => {
  const _items = [...items]
  if (!required) {
    _items.unshift({
      label: 'Alla',
      value: '',
    })
  }

  return _items
}

const Collection = ({
  currentQuery,
  queryKey,
  required,
  defaultValue,
  onChange,
  items,
  label: filterLabel,
}) => {
  const _items = useMemo(() => createItems(items, required), [items, required])

  const selectedValue = currentQuery[queryKey] || defaultValue || ''

  return (
    <Wrapper>
      <TextCallout1>{filterLabel}:</TextCallout1>

      <ItemsWrapper>
        {_items.map(({ label, value }) => {
          const checked = selectedValue === value

          const handleChange = (e) => {
            onChange(e, queryKey, value)
          }

          return (
            <ItemWrapper key={label}>
              <RadioButton
                name={filterLabel}
                label={label}
                checked={checked}
                onChange={handleChange}
                value={value}
                size="tiny"
              />
            </ItemWrapper>
          )
        })}
      </ItemsWrapper>
    </Wrapper>
  )
}

export default Collection

Collection.propTypes = {
  label: PropTypes.string.isRequired,
  currentQuery: PropTypes.object.isRequired,
  queryKey: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  defaultValue: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
}
